module.exports = __webpack_public_path__ + "img/female.a6ef838a.svg";